import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IMarkerIconProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    useMarkerContext
} from "../../context";
import {
    warnOnce
} from "../../../../utils/development";
import AnimatedIcon from "../../../animatedIcon";

const MarkerIcon: FC<IMarkerIconProps> = ({
    customTheme,
    style,
    icon,
    ...props
}) => {
    const context = useMarkerContext();

    const {
        container: containerDynamicStyle
    } = useStyles({
        lineHeight: context?.lineHeight ?? 0
    });

    if(!context) {
        warnOnce({
            message: "Marker.Icon: it must be rendered inside a Marker."
        });

        return null;
    }

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
        aria-hidden={true}
    >
        <AnimatedIcon
            customTheme={customTheme ?? context.customTheme}
            animation={context.isPending ? "spin" : "none"}
            customColor={context.currentColors.iconColor}
            size={context.iconSize}
            icon={icon}
        />
    </View>;
};
export default MarkerIcon;
